import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'


// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData        from '../primitives/localData'
import lmx_Watching         from './Watching' 
import lmx_LocalValues      from './set_LocalValues'
import lmx_draw_Forms       from './draw_Forms'
import lmx_draw_Index       from './draw_Index'
import lmx_draw_Circle      from './draw_Circle'
import lmx_Events           from './Events'


export default {
  
  mixins: [
    gmx_zMixins, 
    lmx_localData,
    
    // Local Mixins
    lmx_Watching,
    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_draw_Index,
    lmx_draw_Circle,
    lmx_Events,
  ],

}
